import { PadService } from './../../../shared/services/pad.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Helper } from '../../../shared/helpers/helper';
import { Router } from '@angular/router';
import { User } from '../../../shared/models/user.model';
import { UserAuthService } from '../../../shared/services/user-auth.service';
import { forEach, filter, some, orderBy } from 'lodash';
import { PadListTableComponent } from '../pad-list-table/pad-list-table.component';
import { ModalConfirmComponent } from '../../../shared/components/modals/confirm/modal-confirm.component';
import { NbDialogService } from '@nebular/theme';
import { UserRolesService } from '../../../shared/services/user-roles.service';
import { LoadingOverlayService } from '../../../shared/services/loading-overlay.service';
import { SortEvent } from '../../../shared/directives/sortable-table-header.directive';

@Component({
  selector: 'app-pad-list',
  templateUrl: './pad-list.component.html',
  styleUrls: ['./pad-list.component.scss']
})
export class PadListComponent implements OnInit, OnDestroy {

  @ViewChild(PadListTableComponent) padTable: PadListTableComponent;
  subscriptions: Subscription[] = [];
  loading: boolean = false;
  // Delete
  isCarboAdmin: boolean = false;

  isService: boolean = false;
  isOperator: boolean = false;

  user: User;

  listPads: any[] = [];
  selectedListPads: any[] = [];
  countPads: number;

  searchFormValues: any;
  // Paging
  pagingState = {
    page: 1,
    pageSize: 20,
    collectionSize: 10
  };
  sortState = {
    sortField: '',
    sortType: false
  };

  selectedSearchParams: any = {};

  constructor(
    private router: Router,
    private userAuthService: UserAuthService,
    private userRolesService: UserRolesService,
    private padService: PadService,
    private dialogService: NbDialogService,
    private loadingOverlayService: LoadingOverlayService
  ) {
    this.user = this.userAuthService.getUserInfo();
    const userRole = this.userRolesService.toUserRole(this.user);
    this.isCarboAdmin = this.userRolesService.isCarboAdmin(userRole);
    if (this.user && this.user.companyType !== 'Service') {
      this.isService = true;
    }
    if (this.user && this.user.companyType !== 'Operator') {
      this.isOperator = true;
    }
  }

  ngOnInit(): void {
    this.loadData();
  }

  ngOnDestroy(): void {
    Helper.unsubscribe(this.subscriptions);
  }

  private loadData(): void {
    this.loading = true;
    this.subscriptions.push(
      this.padService.getListPads(this.searchFormValues, this.pagingState.page, this.pagingState.pageSize, this.sortState.sortField, this.sortState.sortType)
        .subscribe(
          (res) => {
            if (res) {
              this.selectedSearchParams.countries = res.result.selectedCountries;
              this.selectedSearchParams.counties = res.result.selectedCounties;
              this.selectedSearchParams.states = res.result.selectedStates;
              this.selectedSearchParams.formations = res.result.selectedFormations;
              this.selectedSearchParams.operators = res.result.selectedOperators;
              this.selectedSearchParams.services = res.result.selectedServices;

              const listPads = res.result.items;
              this.listPads = forEach(listPads, item => {
                if (some(this.selectedListPads, { padName: item.padName })) {
                  item.selected = true;
                } else {
                  item.selected = false;
                }
              });
              this.pagingState.collectionSize = res.result.totalCount;
            }
            this.loading = false;
          }, (error) => {
            this.loading = false;
          }
        )
    );
  }

  showPadDetails(item: any): void {
    this.router.navigate(['pages', 'pads', `${item.padName}`], {
      queryParams: {
        page: this.pagingState.page
      }
    });
  }

  onSelectedPadChange(event): void {
    if (event && event.selected) {
      const items = filter(event.selected, { selected: true });

      this.selectedListPads = items;
      this.countPads = items.length;
    }
  }

  onSearchPads(eventData): void {
    this.pagingState.page = 1;
    this.searchFormValues = eventData;
    this.loadData();
  }

  onSortPadChange(eventData: SortEvent): void {
    if (eventData) {
      this.sortState.sortField = eventData.column;
      this.sortState.sortType = eventData.direction === 'asc';
      this.loadData();
    }
  }

  onPageChange(page) {
    this.pagingState.page = page;
    this.loadData();
  }

  onCancel(): void {
    this.countPads = 0;
    this.selectedListPads = [];
    this.padTable.removeAllSelected();
    this.loadData();
  }

  onDeleteConfirm(selectedPads): void {
    let padName = 'Pad Operation';
    if (selectedPads && selectedPads.length > 0) {
      const allPadNames = selectedPads.map(item => item.padName);
      padName = `<b>${allPadNames.join(', ')}</b>`;
    }
    this.dialogService.open(ModalConfirmComponent, {
      context: {
        config: {
          title: 'Delete',
          message: `Delete "${padName}" will permanently delete all Well in this Pad data. Are you sure you want to continue?`,
          className: 'pop-delete common-page',
          btnTxtConfirm: 'Yes',
          btnTxtCancel: 'No',
          data: selectedPads,
        }
      }
    })
      .onClose
      .subscribe(res => {
        if (res && res.confirm) {
          this.onDeletePads(res.data);
        }
      });
  }

  onDeletePads(data): void {
    this.loadingOverlayService.show();
    const param = data.map(item => {
      return item.padName;
    });
    this.subscriptions.push(
      this.padService.deletePostPads({data: param}, () => {
        this.loadingOverlayService.hide();
      })
        .subscribe((res) => {
          this.selectedListPads = [];
          this.countPads = 0;
          this.padTable.removeAllSelected();
          this.loadData();
        })
    );
  }

}
